/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */
import { FC, useState } from 'react';

import * as Styles from '@components/modals/styles';
import { ILooseObject } from '@interface/loose-object';
import { AlertDialog, Field, Textarea } from '@versumstudios/ui';

export interface IUserReport {
  // username?: string;
  open?: boolean;
  onOpenChange?: (value: boolean) => void;
  viewer?: string;
  userid?: string;
}

export const UserReport: FC<IUserReport> = ({ open, onOpenChange, viewer, userid }) => {
  const [values, setValues] = useState<ILooseObject>({
    description: { error: false, data: '' },
  });

  const handleChange = (key: string, value: any) => {
    setValues((prevValues) => ({
      ...prevValues,
      [key]: { error: false, data: value },
    }));
  };

  const setError = (key: string, message: string) => {
    setValues((prevValues) => ({
      ...prevValues,
      [key]: { error: message, data: prevValues[key].data },
    }));
  };

  const validate = () => {
    let valid = true;

    if (!values.description.data) {
      setError('description', '"Description" is missing');
      valid = false;
    }

    return valid;
  };

  const handleConfirm = async () => {
    if (validate()) {
      await fetch(`/api/user/${userid}/report`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          viewer,
          message: values.description.data,
        }),
      }).then((e) => e.json());

      if (onOpenChange) {
        onOpenChange(false);
      }
    }
  };

  const handleCancel = () => {
    if (onOpenChange) {
      onOpenChange(false);
    }
  };

  return (
    <AlertDialog
      title="Report User"
      description="Describe why you think this user should be removed from Versum."
      open={open}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
    >
      <Styles.Content>
        <Field
          uid="description"
          tooltip="Though we keep reports anonymous, the reasons for the report are made public so the community can vote on either enforce a ban or not."
          error={values.description.error}
        >
          <Textarea
            placeholder="Tell us some details"
            value={values.description.data}
            onChange={(value: string) => handleChange('description', value)}
          />
        </Field>
      </Styles.Content>
    </AlertDialog>
  );
};
